import { Box, Typography } from '@mui/material';
import React from 'react';
import { Rating } from '@care/react-component-lib';
import useResponsive from '@/components/hooks/useResponsive';

export type TestimonialType = {
  text: string;
  name: string;
};

export const Testimonial = ({ item, index }: { item: TestimonialType; index: number }) => {
  const { isDesktopLG } = useResponsive();

  return (
    <Box
      sx={{
        justifyItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        px: { xs: 2, sm: 0 },
      }}>
      <Box
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          alignSelf: 'center',
          textAlign: 'center',
          backgroundColor: theme.palette.background.default,
          width: { xs: '100%', sm: 482, lg: 410 },
          height: {
            lg: '500px',
          },
          borderRadius: { xs: 6, md: 8 },
          padding: 4,
          ...(index !== 0 &&
            isDesktopLG && {
              marginLeft: 3,
            }),
        })}
        key={`testimonial-card-${item.name}`}>
        <Box sx={{ width: { lg: '346px' } }}>
          <Rating onChange={() => {}} readOnly size="large" value={5} />
          <Typography mt={3} ml="0 !important" variant="body1">
            {item.text}
          </Typography>
        </Box>
        <Typography
          mt={isDesktopLG ? 0 : 4}
          variant={isDesktopLG ? 'body1' : 'body2'}
          color="text.secondary">
          {item.name}
        </Typography>
      </Box>
    </Box>
  );
};

export default Testimonial;
